RivalIQ.apps.Insights.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    widgets.InsightsExportTitle = {
        getExportTitle: function () {
            const me = this;
            const widgetTitle = _.result(me, 'title');

            if (me.isExportFocus()) {
                const exportTitlePrefix = me.curation.getExportTitle();
                const title = _.compact([me.getCompanyName(), widgetTitle]).join(' ');
                return [exportTitlePrefix, title].join(': ');
            } else {
                return widgetTitle;
            }
        },

        getExportSubtitle: function () {
            const me = this;
            if (me.isFocus()) {
                const timezone = RivalIQ.state.landscape.get('timezone');
                return RivalIQ.utils.timePeriod.getTimePeriodDisplayString(me.getProp('timePeriod'), true, timezone);
            }
        },

        isExportFocus: function () {
            const me = this;

            if (me.isExportingPPT()) {
                return !me.getProp('curation');
            }

            return me.isFocus();
        },

        getCompanyName: function () {
            const me = this;
            const companyId = me.getProp('companyId');
            const company = RivalIQ.state.landscape.getCompanyById(companyId);
            return company.get('name');
        }
    };

});
